import { Facility, FleetVehicle } from "./fleetData";
import { fleetColors } from "./fleetMapLayers";
import type { FleetLabelFields } from "./useFleetEstimates";

export function createFleetHover(vehicle: FleetVehicle, facilities: Facility[], metrics?: FleetLabelFields): HTMLElement {
  const root=document.createElement("section"); root.className="fleet-hover-details";
  root.setAttribute("aria-label",vehicle.plate+" details");
  root.style.setProperty("--fleet-hover-accent",vehicle.unreachable?fleetColors.stale:fleetColors[vehicle.status]);
  const title=document.createElement("strong"); title.textContent=vehicle.plate; root.appendChild(title);
  const list=document.createElement("dl"); root.appendChild(list);
  const add=(name:string,value:unknown) => {
    const row=document.createElement("div"), label=document.createElement("dt"), text=document.createElement("dd");
    label.textContent=name; text.textContent=value==null || value===""?"Unavailable":String(value);
    row.append(label,text); list.appendChild(row);
  };
  add("Speed",metrics?.speed || "— km/h");
  add("Road distance",metrics?.distance || "— km");
  add("Travel time",metrics?.time || "— min");
  return root;
}

// Set only from a confirmed vehicle specification; battery percentage alone
// does not establish how far a loaded trailer can travel.
export function createBatteryHover(vehicle: FleetVehicle, fullChargeRangeKm?: number): HTMLElement {
  const root=document.createElement("section");root.className="fleet-hover-details";
  root.setAttribute("aria-label",vehicle.plate+" battery details");
  root.style.setProperty("--fleet-hover-accent",fleetColors[vehicle.status]);
  const title=document.createElement("strong");title.textContent=vehicle.plate;root.appendChild(title);
  const list=document.createElement("dl");root.appendChild(list);
  const add=(label:string,value:string)=>{
    const row=document.createElement("div"),dt=document.createElement("dt"),dd=document.createElement("dd");
    dt.textContent=label;dd.textContent=value;row.append(dt,dd);list.appendChild(row);
  };
  const battery=vehicle.telemetry?.battery;
  const valid=typeof battery==="number" && Number.isFinite(battery) && battery>=0 && battery<=100 && !vehicle.unreachable && !vehicle.telemetry?.stale && !vehicle.telemetry?.metricsStale;
  add("Battery",valid?`${Math.round(battery!)}%`:"Unavailable");
  const rangeValid=typeof fullChargeRangeKm==="number" && Number.isFinite(fullChargeRangeKm) && fullChargeRangeKm>0;
  add("Estimated range left",valid && rangeValid?`~${Math.round(battery!*fullChargeRangeKm!/100)} km`:"—");
  if(valid && rangeValid) {
    const note=document.createElement("small");note.textContent="Based on charge level; load, terrain and driving affect range.";root.appendChild(note);
  }
  return root;
}
